'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002419 from "./presto.-Agent-View$$anon$19.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dCert$002dChain$002dRequest$0024 from "./presto.-Agent-View$-Local-Pje-Office-Cert-Chain-Request$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$18() {
  this.awN = null;
  this.awF = null;
  this.awG = false;
  this.awO = null;
  this.awP = false;
  this.awS = null;
  this.awL = null;
  this.awM = false;
  this.awH = null;
  this.awI = false;
  this.awJ = null;
  this.awK = false;
  this.awQ = false;
  this.awR = false;
  this.awN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.awS = "LocalPjeOfficeCertChainRequest";
}
export { $c_Lpresto_AgentView$$anon$18 as $c_Lpresto_AgentView$$anon$18 };
$p = $c_Lpresto_AgentView$$anon$18.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$18;
/** @constructor */
function $h_Lpresto_AgentView$$anon$18() {
}
export { $h_Lpresto_AgentView$$anon$18 as $h_Lpresto_AgentView$$anon$18 };
$h_Lpresto_AgentView$$anon$18.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.awN;
});
$p.L = (function() {
  if ((!this.awG)) {
    this.awF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.awG = true;
  }
  return this.awF;
});
$p.O = (function() {
  if ((!this.awP)) {
    this.awO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.awP = true;
  }
  return this.awO;
});
$p.E = (function() {
  return this.awS;
});
$p.t = (function() {
  if ((!this.awM)) {
    this.awL = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.awM = true;
  }
  return this.awL;
});
$p.M = (function() {
  if ((!this.awI)) {
    this.awH = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fd(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.awI = true;
  }
  return this.awH;
});
$p.Q = (function() {
  if ((!this.awK)) {
    this.awJ = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002419.$c_Lpresto_AgentView$$anon$19();
    this.awK = true;
  }
  return this.awJ;
});
$p.w = (function() {
  if ((!this.awR)) {
    this.awQ = false;
    this.awR = true;
  }
  return this.awQ;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee120) => ((p) => \u03b4scrutinee120.cFM(p)))($j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dCert$002dChain$002dRequest$0024.$m_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$())));
});
var $d_Lpresto_AgentView$$anon$18 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$18, "presto.AgentView$$anon$18", ({
  DG: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$18 as $d_Lpresto_AgentView$$anon$18 };
//# sourceMappingURL=presto.-Agent-View$$anon$18.js.map
